import { useEffect, useState } from "react";

const IOS_PATTERNS = [/iPhone/i, /iPad/i, /iPod/i];
const MOBILE_PATTERNS = [
  /Android/i,
  /webOS/i,
  /BlackBerry/i,
  /Windows Phone/i,
  ...IOS_PATTERNS,
];

const execRegex = (target, pattern) => {
  const regexPattern = new RegExp(pattern);
  return !!regexPattern.exec(target);
};

const isMobileDevice = (userAgent): boolean => {
  return MOBILE_PATTERNS.some((pattern) => execRegex(userAgent, pattern));
};

const useTestMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean>(true);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsMobile(isMobileDevice(navigator.userAgent));
    }
  }, [isMobile]);

  return isMobile;
};

export default useTestMobile;
